import React, { useContext, useEffect, useState } from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { message, Row, Col, Card } from 'antd';
import Form from './Form/Index';
import { ParamsContext } from '../Context/ParamsContext';

const Update = (props) => {
  const [loading, setLoading] = useState(true);
  const [vendor, setVendor] = useState({});
  const { id } = useContext(ParamsContext);

  useEffect(() => {
    fetchVendorDetail();
  }, [id]);

  const fetchVendorDetail = () => {
    setLoading(true);
    const url = `/vendor/detail?id=${id}`;
    axios.get(url).then(resp => {
      setVendor(resp.data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat detail perusahaan");
    });
  }

  return (
    <Auxiliary>
      <Title>Perbarui Perusahaan</Title>
      {loading ? "Sedang memuat..." : (
        <Row>
          <Col span={16}>
            <Card className="gx-card">
              <Form vendor={vendor} />
            </Card>
          </Col>
        </Row>
      )}
    </Auxiliary>
  );
}

export default Update;